module.exports = __webpack_public_path__ + "img/four2Blue.b3aeaee7.jpg";